import { SQLiteDBConnection } from "@capacitor-community/sqlite";
import { LoggerService } from '../../utils/logger.service';

export class SqliRequest {
    private request
    private args
    private callback
    private errorCallback
    private _resolve
    private _reject
    constructor(request: string, args: any[] = [], callback: Function = null, errorCallback: Function = null) {
        this.request = request;
        this.args = args;
        this.callback = callback;
        this.errorCallback = errorCallback;

    }

    execute(tx: SQLiteDBConnection) {
        return new Promise((resolve, reject) => {
            this._resolve = resolve
            this._reject = reject
            tx.query(this.request, this.args).then(this.cb).catch(this.error)
        })
    }

    private cb = (res) => {
        if (this.callback) {
            this?.callback(res)
        } else {
            LoggerService.debug('Résultat de la requête SQL', res)
        }
        this._resolve(res)
    }

    private error = (err) => {
        if (this.errorCallback) {
            this?.errorCallback(err)
        } else {
            LoggerService.error('Erreur lors de l\'exécution de la requête SQL', err)
        }
        this._reject(err)
    }

}
